module.exports = __webpack_public_path__ + "static/img/python.e5d6906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/python.png
// module id = f19dbcdb783592d3
// module chunks = 59